import { createContext, useContext } from 'react';

export const CalcUuidContext = createContext(null);
export const useCalcUuid = () => useContext(CalcUuidContext);
